// extracted by mini-css-extract-plugin
module.exports = {"EFPic":"EFPic_EFPic__2s6_7"};